// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.permission_dashboard__trZBo {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.permission_dashboardContain__O58ha {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.permission_bodythemedark__XkwvC .permission_dashboardContain__O58ha,
.permission_bodythemedark__XkwvC .permission_dashboard__trZBo,
.permission_bodythemedark__XkwvC .permission_cont2__iqnOJ {
  background-Color: #0f1824;
}

.permission_top_header__lqhhn .permission_top_header_inner__SqkYo {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.permission_cont2__iqnOJ {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.permission_subLink__dAj0q svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.permission_footer__hkdaT {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.permission_bodythemelight__fmQA5 {
  background-color: #fff;
  padding-top: 90px;
}

.permission_bodythemedark__XkwvC {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.permission_headerthemelight__ODmWd {
  background-color: #fff;
}

.permission_headerthemedark__2bUg8 {
  background-color: #132337;
}

.permission_top_header__lqhhn {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.permission_menuthemelight__6XcHs {
  background-color: #fff;
}

.permission_menuthemedark__vs1M9 {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.permission_menulinklight__WyuVg span {
  color: #666666 !important;
}

.permission_menulinklight__WyuVg a {
  color: #CBCBCB !important;
}

.permission_menulinklight__WyuVg:hover span, .permission_menulinklight__WyuVg:hover a {
  color: #fff !important;
}

.permission_menulinkdarkSelected__GZf5Y {
  background-color: #1c2e45;
  color: #3b82f6;
}

.permission_menuthemelight__6XcHs .permission_menulinklightSelected__mdnmD {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.permission_menulinkdark__bvebz {
  color: #92afd3 !important;
}

.permission_menulinklight__WyuVg:hover {
  color: #fff !important;
  background-color: #131F43;
}

.permission_menulinklight__WyuVg .permission_sub_arrow__nfMyX svg path {
  stroke: #CBCBCB !important;
}

.permission_menulinklight__WyuVg:hover .permission_sub_arrow__nfMyX svg path {
  stroke: #fff !important;
}

.permission_menulinkdark__bvebz .permission_sub_arrow__nfMyX svg path {
  stroke: #92afd3 !important;
}

.permission_menulinkdark__bvebz:hover .permission_sub_arrow__nfMyX svg path {
  stroke: #fff !important;
}

.permission_menulinkdark__bvebz:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.permission_headinglight__4qiPL {
  color: #60677e;
}

.permission_headingdark__wak8G {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.permission_searchboxlight__JGCey {
  background-color: #fff;
  border: none;
}

.permission_searchboxdark__jT6xn {
  background-color: #132337;
  color: #fff;
  border: none;
}

.permission_searchboxdark__jT6xn::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.permission_tableheadlight__I\\+kRx {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.permission_tableheadlight__I\\+kRx th {
  color: #fff;
}

thead .permission_tableheadlight__I\\+kRx th:first-child,
thead .permission_tableheaddark__DuUFJ th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .permission_tableheadlight__I\\+kRx th:last-child,
thead .permission_tableheaddark__DuUFJ th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.permission_table__XT-ty.permission_table-borderless__X6k-U {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.permission_tableheaddark__DuUFJ {
  background-color: #132337;
  color: #fff;
}

.permission_table-borderless__X6k-U tr:nth-child(even) {
  background-color: #F9FAFB;
}

.permission_table-borderless__X6k-U .permission_left-section__bfe0E {
  padding-top: 10px;
}

.permission_tablebodylight__NPM54 td,
.permission_tablebodydark__oMsml td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.permission_tablebodylight__NPM54 {
  background-color: #fff;
}
.permission_tablebodylight__NPM54:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.permission_tablebodydark__oMsml {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.permission_tablebodydark__oMsml:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.permission_paginationlight__0EWCD {
  color: #60677e !important;
  font-size: 13px !important;
}

.permission_paginationdark__G881y {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.permission_formthemelight__cJjED {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.permission_formthemedark__CMNcL {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.permission_formthemedark__CMNcL ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.permission_viewformlight__JoyPF {
  background-color: #f3f6f9;
}

.permission_permissionboxlight__nZ0Qn {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.permission_permissionboxdark__GhFcv {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.permission_errormsgclr__uWUDR {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.permission_graphclrlight__ywHb- {
  background-color: #fff;
}

.permission_graphclrdark__6LuZv {
  background-color: #132337;
}

/* 
Counter theme
*/
#permission_card1bglight__2QJSX {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#permission_card1bgdark__ogZMV {
  background: #392f28;
}

#permission_card2bglight__412IJ {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#permission_card2bgdark__eZxGd {
  background: #1c3238;
}

#permission_card3bglight__SZzuz {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#permission_card3bgdark__KC6E5 {
  background: #3a2434;
}

#permission_card4bglight__pPoEz {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#permission_card4bgdark__RILjM {
  background: #2f264f;
}

#permission_card1bgdark__ogZMV a, #permission_card1bgdark__ogZMV p,
#permission_card2bgdark__eZxGd a, #permission_card2bgdark__eZxGd p,
#permission_card3bgdark__KC6E5 a, #permission_card3bgdark__KC6E5 p,
#permission_card4bgdark__RILjM a, #permission_card4bgdark__RILjM p {
  color: #fff;
}

/* 
Action button theme
*/
.permission_actionbtnlight__PztFs {
  color: rgba(70, 71, 91, 0.8705882353);
}

.permission_actionbtnlight__PztFs:hover {
  cursor: pointer;
}

.permission_actionbtndark__5iyfi {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.permission_profiledropdownlight__Rs1Bl {
  background-color: #fff;
}

.permission_profiledropdowndark__7jL8q {
  background-color: #151521;
}

.permission_settingsection__8w894 #permission_addform__MEvmb.permission_formthemedark__CMNcL .permission_savebtn__BwORb {
  background-color: #3b82f6;
  color: #fff;
}

#permission_addform__MEvmb.permission_formthemedark__CMNcL .permission_savebtn__BwORb {
  background-color: #3b82f6;
  color: #fff;
}

.permission_profile_conatiner__sPB0U {
  border-radius: 5px !important;
}

.permission_bodythemedark__XkwvC .permission_ag-theme-alpine__fBf6W .permission_ag-row__9YwCz {
  background: #000 !important;
}

.permission_bodythemedark__XkwvC .permission_formbtn__kh\\+zH {
  background-color: #3b82f6;
}

.permission_bodythemedark__XkwvC .permission_formbtn__kh\\+zH:hover {
  background-color: #2563eb;
}

.permission_bodythemedark__XkwvC .permission_resetbtn__tL5-t {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.permission_bodythemedark__XkwvC .permission_resetbtn__tL5-t:hover {
  background-color: #3b82f6;
}

.permission_headingdark__wak8G span {
  background-color: #132337;
}

.permission_resetbtn__tL5-t {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.permission_resetbtn__tL5-t:hover,
.permission_resetbtn__tL5-t:active,
.permission_resetbtn__tL5-t:focus {
  background-color: #131F43;
  color: #fff;
}

.permission_addBtn__0HPTd {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.permission_addbtnlight__vlEio {
  background-color: #38A169;
}

.permission_addbtndark__PSJ5Q {
  background-color: #3b82f6;
}

.permission_addbtndark__PSJ5Q:hover {
  background-color: #2563eb;
}

.permission_formthemedark__CMNcL label {
  color: #92afd3;
}

.permission_addBtn__0HPTd svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.permission_addBtn__0HPTd:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.permission_cust_addBtn__MZkL\\+.permission_addBtn__0HPTd svg {
  top: 2px;
}

.permission_deleteBtn__sPFAv {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.permission_deleteBtn__sPFAv {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.permission_deleteBtn__sPFAv:active, .permission_deleteBtn__sPFAv:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.permission_deleteBtn__sPFAv svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.permission_deleteBtn__sPFAv:hover,
.permission_deleteBtn__sPFAv:active,
.permission_deleteBtn__sPFAv:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.permission_confirmBtn__HoO1d {
  background-color: #131F43;
}

.permission_confirmBtn__HoO1d:hover,
.permission_confirmBtn__HoO1d:active,
.permission_confirmBtn__HoO1d:focus {
  background-color: #131F43;
}

.permission_confirmBtn__HoO1d svg {
  top: 0;
}

.permission_delPopContainer__dckSq .permission_modal-body__1wrgv {
  padding: 25px;
  text-align: center;
}

.permission_delPopContainer__dckSq .permission_delet_icon__oC7-u {
  margin-bottom: 11px;
}

.permission_delPopContainer__dckSq p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.permission_arrowback__7LrcK svg {
  fill: #000;
}

.permission_bodythemedark__XkwvC .permission_arrowback__7LrcK {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.permission_bodythemedark__XkwvC .permission_arrowback__7LrcK svg {
  fill: #3b82f6;
}

.permission_bodythemedark__XkwvC .permission_drpdwn_btn__K-uGw {
  background-color: #132337;
}

.permission_bodythemedark__XkwvC .permission_empname__OiSi9 {
  color: #92afd3 !important;
}

.permission_bodythemedark__XkwvC .permission_navitemli__EE0oj a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.permission_bodythemedark__XkwvC .permission_tabnavli__aU6M6 a.permission_settingsgeneral__ll13g,
.permission_bodythemedark__XkwvC .permission_tabnavli__aU6M6 a.permission_settingslinks__w3fgp:hover {
  background-color: #3b82f6;
  color: #fff;
}

.permission_bodythemedark__XkwvC .permission_tabnavli__aU6M6 a.permission_settingslinks__w3fgp {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.permission_headerthemedark__2bUg8 .permission_dropdown_menu_contain__1te\\+M {
  background-color: #1c2e45;
  color: #fff;
}

.permission_headerthemedark__2bUg8 .permission_dropdown_menu_contain__1te\\+M ul li a,
.permission_headerthemedark__2bUg8 .permission_dropdown_menu_contain__1te\\+M .permission_dropdown_item__A1Go0,
.permission_headerthemedark__2bUg8 .permission_dropdown_menu_contain__1te\\+M .permission_dropdown_item__A1Go0 h5 {
  color: #fff;
}

.permission_headerthemedark__2bUg8 .permission_dropdown_menu_contain__1te\\+M ul li a:hover,
.permission_headerthemedark__2bUg8 .permission_dropdown_menu_contain__1te\\+M .permission_dropdown_item__A1Go0:hover {
  background-color: #132337;
  color: #fff;
}

.permission_dropdown_item__A1Go0:active {
  background-color: #F5F6FA;
}

.permission_profile_arrrow_dwn__VL1yK {
  stroke: #132337;
}

.permission_headerthemedark__2bUg8 .permission_profile_arrrow_dwn__VL1yK {
  stroke: #fff;
}

.permission_dateinputbox1__P4\\+Wu input,
.permission_dateinputbox1__P4\\+Wu span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .permission_tableheadlight__I\\+kRx th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .permission_dashboard__trZBo {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .permission_cont2__iqnOJ {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .permission_sectionright__Sin3c {
    float: unset !important;
  }
  .permission_dashboard__trZBo {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .permission_cont2__iqnOJ {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .permission_bodythemelight__fmQA5, .permission_bodythemedark__XkwvC {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .permission_exer_modal_contain__on0Mh .permission_modal-dialog__wX3oc {
    max-width: 1055px;
  }
  .permission_delPopContainer__dckSq .permission_modal-dialog__wX3oc {
    max-width: 350px;
  }
}
#permission_notfoundbg__P8qJv {
  height: 100vh;
}

.permission_centerbox__PW--D {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  color: #1d1d1d;
  align-items: center;
  height: max-content;
}

.permission_imgdiv__z5Pai {
  justify-content: center;
  display: flex;
}

.permission_pagenotimage__VeDrD {
  width: 250px;
  height: 200px;
}

.permission_pagenotfoundhead__SVAzt {
  font-size: 30px;
  color: #28305f;
  text-align: center;
  margin-top: 10px;
}

.permission_pagenotfoundpara__\\+Le6\\+ {
  font-size: 18px;
  color: #28305f;
  text-align: center;
}

.permission_btnsection__WeQYN {
  display: flex;
  justify-content: center;
}

.permission_gohomebtn__waeHK {
  background-color: #28305f;
  color: #fff;
  border: none;
  padding: 6px 20px 6px 20px;
  border-radius: 6px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/permission/permission.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAmDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA3FO;EA4FP,2BAAA;EACA,gBAAA;ACzEF;;AD2EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACxEF;;AD0EA;;;EAGE,yBAlEoB;ACLtB;;ADyEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACtEF;;ADyEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAzHO;EA0HP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACpEF;;AD0EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACvEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBAjGY;ACwBd;;AD4EA;;CAAA;AAGA;EACE,sBAxGY;EAyGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAvHgB;EAwHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBApHY;AC4Cd;;AD2EA;EACE,yBAnIgB;AC2DlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAxIY;ACiEd;;ADyEA;EACE,yBAtJgB;ACgFlB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAvKsB;EAwKtB,cAlLkB;AC4GpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBAlNc;AC6IhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBA3Nc;ACsJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBA1MsB;EA2MtB,WAlMY;AC6Hd;;ADwEA;;CAAA;AAGA;EACE,cAtMe;ACiIjB;;ADwEA;EACE,cA1Me;ACqIjB;;ADwEA;;CAAA;AAGA;EACE,sBApNY;EAqNZ,YAAA;ACrEF;;ADwEA;EACE,yBApOgB;EAqOhB,WA1NY;EA2NZ,YAAA;ACrEF;;ADuEA;EACE,cA3Ne;ACuJjB;;ADuEA;;CAAA;AAGA;EACE,yBAnRc;EAoRd,8BAAA;ACpEF;;ADsEA;EACE,WAzOY;ACsKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAvPkB;EAwPlB,WAhQY;ACkMd;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBA9QY;ACoNd;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cApRe;AC0NjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA/SY;EAgTZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBA5SkB;EA6SlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAtTa;AC6PjB;;AD8DA;;CAAA;AAGA;EACE,yBArUgB;AC0QlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBApVoB;EAqVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAxVY;AC8Rd;;AD6DA;EACE,yBApVkB;AC0RpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBArWY;AC0Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA9WY;ACmTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAvXY;AC4Td;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAhYY;ACqUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WA3YY;ACgVd;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cArZe;AC4VjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBAzbkB;EA0blB,WAzaY;AC+Wd;;AD4DA;EACE,yBA7bkB;EA8blB,WA7aY;ACoXd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBA1ckB;ACiZpB;;AD4DA;EACE,yBA7cwB;ACoZ1B;;AD4DA;EACE,WAjcY;EAkcZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAxdkB;AC+ZpB;;AD6DA;EACE,yBAvdgB;AC6ZlB;;AD6DA;EACE,eAAA;EACA,gBArgBc;EAsgBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAngBc;EAogBd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAzgBc;EA0gBd,WA5dY;ACmad;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WAleY;EAmeZ,yBA9fY;EA+fZ,YAAA;EACA,eAAA;EACA,gBA1hBc;ACiehB;;AD4DA;EACE,yBArgBY;AC4cd;;AD2DA;EACE,yBA9fkB;ACscpB;;AD0DA;EACE,yBAhgBwB;ACyc1B;;AD0DA;EACE,cAtgBiB;AC+cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA/fY;EAggBZ,yBA3hBY;EA4hBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA/hBW;EAgiBX,WA5gBY;EA6gBZ,eAAA;EACA,gBAlkBc;EAmkBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBAziBW;EA0iBX,WAthBY;EAuhBZ,eAAA;EACA,gBA5kBc;EA6kBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA/jBW;EAgkBX,WA5iBY;EA6iBZ,YAAA;ACxDF;;AD2DA;EACE,yBA/lBc;ACuiBhB;;AD2DA;;;EAGE,yBArmBc;AC6iBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCAnmBc;EAomBd,cAxmBkB;AC8iBpB;;AD6DA;EACE,aA5mBkB;ACkjBpB;;AD6DA;EACE,yBAxmBgB;AC8iBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAvmBY;AC6iBd;;AD6DA;;EAEE,yBA7nBkB;EA8nBlB,WA7mBY;ACmjBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlnBY;ACyjBd;;AD4DA;EACE,yBA/nBsB;EAgoBtB,WAvnBY;AC8jBd;;AD4DA;;;EAGE,WA7nBY;ACokBd;;AD4DA;;EAEE,yBA7oBgB;EA8oBhB,WAnoBY;AC0kBd;;AD4DA;EACE,yBAtrBO;AC6nBT;;AD4DA;EACE,eAtpBgB;AC6lBlB;;AD4DA;EACE,YA/oBY;ACslBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AA1sBA;EACI,aAAA;AA4sBJ;;AA1sBA;EAEI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,cDmDU;EClDV,mBAAA;EACA,mBAAA;AA4sBJ;;AAzsBA;EACI,uBAAA;EACA,aAAA;AA4sBJ;;AAzsBA;EACI,YAAA;EACA,aAAA;AA4sBJ;;AA1sBA;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA6sBJ;;AA3sBA;EACI,eAAA;EAEA,cAAA;EACA,kBAAA;AA6sBJ;;AA1sBA;EACI,aAAA;EACA,uBAAA;AA6sBJ;;AA3sBA;EACI,yBAAA;EACA,WDiBU;EChBV,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;AA8sBJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #DBEAFE;  \n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #D1FAE5;  \n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FEF3C7;  \n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #E9D5FF; \n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon1-color: #3B82F6;  \n$cardIcon2-color: #10B981;  \n$cardIcon3-color: #F59E0B;  \n$cardIcon4-color: #8B5CF6;  \n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"/src/styles/Variables/Variables.scss\";\n\n#notfoundbg{\n    height: 100vh;\n}\n.centerbox{\n  \n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    color: $black-color;\n    align-items: center;\n    height: max-content;\n}\n\n.imgdiv{\n    justify-content: center;\n    display: flex;\n}\n\n.pagenotimage{\n    width: 250px;\n    height: 200px;\n}\n.pagenotfoundhead{\n    font-size: 30px;\n    color: #28305f;\n    text-align: center;\n    margin-top: 10px;\n}\n.pagenotfoundpara{\n    font-size: 18px;\n     \n    color: #28305f;\n    text-align: center;\n}\n\n.btnsection{\n    display: flex;\n    justify-content: center;\n}\n.gohomebtn{\n    background-color: #28305f;\n    color: $white-color;\n    border: none;\n    padding: 6px 20px 6px 20px;\n    border-radius: 6px;\n    font-size: 14px;\n     \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `permission_dashboard__trZBo`,
	"dashboardContain": `permission_dashboardContain__O58ha`,
	"bodythemedark": `permission_bodythemedark__XkwvC`,
	"cont2": `permission_cont2__iqnOJ`,
	"top_header": `permission_top_header__lqhhn`,
	"top_header_inner": `permission_top_header_inner__SqkYo`,
	"subLink": `permission_subLink__dAj0q`,
	"footer": `permission_footer__hkdaT`,
	"bodythemelight": `permission_bodythemelight__fmQA5`,
	"headerthemelight": `permission_headerthemelight__ODmWd`,
	"headerthemedark": `permission_headerthemedark__2bUg8`,
	"menuthemelight": `permission_menuthemelight__6XcHs`,
	"menuthemedark": `permission_menuthemedark__vs1M9`,
	"menulinklight": `permission_menulinklight__WyuVg`,
	"menulinkdarkSelected": `permission_menulinkdarkSelected__GZf5Y`,
	"menulinklightSelected": `permission_menulinklightSelected__mdnmD`,
	"menulinkdark": `permission_menulinkdark__bvebz`,
	"sub_arrow": `permission_sub_arrow__nfMyX`,
	"headinglight": `permission_headinglight__4qiPL`,
	"headingdark": `permission_headingdark__wak8G`,
	"searchboxlight": `permission_searchboxlight__JGCey`,
	"searchboxdark": `permission_searchboxdark__jT6xn`,
	"tableheadlight": `permission_tableheadlight__I+kRx`,
	"tableheaddark": `permission_tableheaddark__DuUFJ`,
	"table": `permission_table__XT-ty`,
	"table-borderless": `permission_table-borderless__X6k-U`,
	"left-section": `permission_left-section__bfe0E`,
	"tablebodylight": `permission_tablebodylight__NPM54`,
	"tablebodydark": `permission_tablebodydark__oMsml`,
	"paginationlight": `permission_paginationlight__0EWCD`,
	"paginationdark": `permission_paginationdark__G881y`,
	"formthemelight": `permission_formthemelight__cJjED`,
	"formthemedark": `permission_formthemedark__CMNcL`,
	"viewformlight": `permission_viewformlight__JoyPF`,
	"permissionboxlight": `permission_permissionboxlight__nZ0Qn`,
	"permissionboxdark": `permission_permissionboxdark__GhFcv`,
	"errormsgclr": `permission_errormsgclr__uWUDR`,
	"graphclrlight": `permission_graphclrlight__ywHb-`,
	"graphclrdark": `permission_graphclrdark__6LuZv`,
	"card1bglight": `permission_card1bglight__2QJSX`,
	"card1bgdark": `permission_card1bgdark__ogZMV`,
	"card2bglight": `permission_card2bglight__412IJ`,
	"card2bgdark": `permission_card2bgdark__eZxGd`,
	"card3bglight": `permission_card3bglight__SZzuz`,
	"card3bgdark": `permission_card3bgdark__KC6E5`,
	"card4bglight": `permission_card4bglight__pPoEz`,
	"card4bgdark": `permission_card4bgdark__RILjM`,
	"actionbtnlight": `permission_actionbtnlight__PztFs`,
	"actionbtndark": `permission_actionbtndark__5iyfi`,
	"profiledropdownlight": `permission_profiledropdownlight__Rs1Bl`,
	"profiledropdowndark": `permission_profiledropdowndark__7jL8q`,
	"settingsection": `permission_settingsection__8w894`,
	"addform": `permission_addform__MEvmb`,
	"savebtn": `permission_savebtn__BwORb`,
	"profile_conatiner": `permission_profile_conatiner__sPB0U`,
	"ag-theme-alpine": `permission_ag-theme-alpine__fBf6W`,
	"ag-row": `permission_ag-row__9YwCz`,
	"formbtn": `permission_formbtn__kh+zH`,
	"resetbtn": `permission_resetbtn__tL5-t`,
	"addBtn": `permission_addBtn__0HPTd`,
	"addbtnlight": `permission_addbtnlight__vlEio`,
	"addbtndark": `permission_addbtndark__PSJ5Q`,
	"cust_addBtn": `permission_cust_addBtn__MZkL+`,
	"deleteBtn": `permission_deleteBtn__sPFAv`,
	"confirmBtn": `permission_confirmBtn__HoO1d`,
	"delPopContainer": `permission_delPopContainer__dckSq`,
	"modal-body": `permission_modal-body__1wrgv`,
	"delet_icon": `permission_delet_icon__oC7-u`,
	"arrowback": `permission_arrowback__7LrcK`,
	"drpdwn_btn": `permission_drpdwn_btn__K-uGw`,
	"empname": `permission_empname__OiSi9`,
	"navitemli": `permission_navitemli__EE0oj`,
	"tabnavli": `permission_tabnavli__aU6M6`,
	"settingsgeneral": `permission_settingsgeneral__ll13g`,
	"settingslinks": `permission_settingslinks__w3fgp`,
	"dropdown_menu_contain": `permission_dropdown_menu_contain__1te+M`,
	"dropdown_item": `permission_dropdown_item__A1Go0`,
	"profile_arrrow_dwn": `permission_profile_arrrow_dwn__VL1yK`,
	"dateinputbox1": `permission_dateinputbox1__P4+Wu`,
	"sectionright": `permission_sectionright__Sin3c`,
	"exer_modal_contain": `permission_exer_modal_contain__on0Mh`,
	"modal-dialog": `permission_modal-dialog__wX3oc`,
	"notfoundbg": `permission_notfoundbg__P8qJv`,
	"centerbox": `permission_centerbox__PW--D`,
	"imgdiv": `permission_imgdiv__z5Pai`,
	"pagenotimage": `permission_pagenotimage__VeDrD`,
	"pagenotfoundhead": `permission_pagenotfoundhead__SVAzt`,
	"pagenotfoundpara": `permission_pagenotfoundpara__+Le6+`,
	"btnsection": `permission_btnsection__WeQYN`,
	"gohomebtn": `permission_gohomebtn__waeHK`
};
export default ___CSS_LOADER_EXPORT___;
